import { useState } from 'react'
import { family } from '../lib/chores'

/**
 * Everything in the app is scoped to a household, so this is the first screen a
 * new parent sees. Two doors: start one, or join one with a code.
 */
export default function Household({ onDone }: { onDone: () => Promise<void> }) {
  const [name, setName] = useState('')
  const [code, setCode] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function run(fn: () => Promise<unknown>) {
    setBusy(true); setError(null)
    try { await fn(); await onDone() } catch (e) { setError((e as Error).message) } finally { setBusy(false) }
  }

  return (
    <>
      <section className="card">
        <h1>Start a household</h1>
        <label>What do you call it?
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="The Forgues house" />
        </label>
        <button className="primary" disabled={busy} onClick={() => run(() => family.create(name))}>Create it</button>
      </section>

      <section className="card">
        <h2>Or join one</h2>
        <p className="muted small">The other parent can find the code on their household screen.</p>
        <label>Invite code
          <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} autoCapitalize="characters" />
        </label>
        <button disabled={busy || !code} onClick={() => run(() => family.join(code))}>Join</button>
        {error && <p className="error" role="alert">{error}</p>}
      </section>
    </>
  )
}
